import { useState, useEffect, useRef } from "react";
/**
 * Custom hook that debounces a value.
 * @param {any} value - The value to debounce.
 * @param {number} delay - The debounce delay in milliseconds.
 * @returns {any} - The debounced value.
 */
export function useDebounce(value:any, delay = 300) {
    const [debouncedValue, setDebouncedValue] = useState(value);
    
    // Use a ref to keep track of the timeout ID
    const timeoutRef = useRef(0);
    
    useEffect(() => {
        // Clear the previous timeout if it exists
        if (timeoutRef.current > 0) {
            clearTimeout(timeoutRef.current);
        }
    
        // Set a new timeout to update the debounced value
        timeoutRef.current = window.setTimeout(() => {
            setDebouncedValue(value);
        }, delay);
    
        // Cleanup function to clear the timeout on unmount or value change
        return () => {
            clearTimeout(timeoutRef.current);
        };
    }, [value, delay]);
    
    return debouncedValue;
}
